import { createSelector } from 'reselect';
var selectSearchCriteriaState = function (_a) {
    var searchCriteria = _a.searchCriteria;
    return searchCriteria;
};
/**
 * Selects the isFetching flag from the state
 */
export var searchCriteriaLoadingSelector = createSelector(selectSearchCriteriaState, function (_a) {
    var isFetching = _a.isFetching;
    return isFetching;
});
/**
 * Selects the possible error from the state
 */
export var searchCriteriaErrorSelector = createSelector(selectSearchCriteriaState, function (_a) {
    var didInvalidate = _a.didInvalidate, error = _a.error;
    return (didInvalidate ? error : false);
});
/**
 * Selects the entities of the state
 */
export var searchCriteriaEntitiesSelector = createSelector(selectSearchCriteriaState, function (_a) {
    var _b = _a.ids, ids = _b === void 0 ? [] : _b, _c = _a.entities, entities = _c === void 0 ? {} : _c;
    return ids.map(function (id) { return entities[id]; });
});
/**
 * Compose all the previous selectors to return all the the relevant information
 * from the state
 */
export var searchCriteriaStateSelector = createSelector(searchCriteriaLoadingSelector, searchCriteriaEntitiesSelector, searchCriteriaErrorSelector, function (loading, data, error) { return ({ loading: loading, data: data, error: error }); });
